import $ from 'jquery';

const setMailTo = () => {
  const mail = mailConvert(String.fromCharCode(106,111,103,112,46,116,118,115,103,65,101,102,98,115,116,99,115,98,106,111,47,107,113)),
        link = String.fromCharCode(109,97,105,108,116,111,58)+mail,
        html = '<a href="' + link + '">' + mail + '</a>';
  $('#mail').html(html);
};

const mailConvert = (c) => {
  let str ='',
      tmp = '';
  for(let i=0; i<c.length; i++){
    tmp = c.charCodeAt(i);
    str += String.fromCharCode(tmp - 1);
  }
  return str;
};

module.exports = {
  setMailTo : setMailTo
};



// WEBPACK FOOTER //
// ./src/js/modules/common.js